if (!customElements.get('hh-offer-picker')) {
  class HHOfferPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.root = document.getElementById('ProductInfo-' + this.dataset.section) || this.closest('.product__info-container');
      if (!this.root) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-roamellow-variants]').textContent);
      this.selection = [{style:'Black',size:'S'},{style:'Black',size:'S'},{style:'Black',size:'S'}];
      this.root.classList.add('hh-has-offers');
      this.dataset.ready = 'true';
      this.syncPreferences();
      this.changeHandler = event => {
        event.stopPropagation();
        if (event.target.matches('input[type="radio"]')) this.paint(event.target.dataset.count);
        if (event.target.matches('[data-roamellow-size]')) {
          const row = event.target.closest('[data-pair]');
          this.selection[Number(row.dataset.pair)] = {style:'Black',size:row.querySelector('[data-roamellow-size]').value};
          this.syncSelections();
          this.updateForm();
        }
        for (const [selector,key] of [['[data-hh-protection]','protection'],['[data-hh-mystery-gift]','gift']]) {
          if (event.target.matches(selector)) {
            this.querySelectorAll(selector).forEach(input => { input.checked = event.target.checked; });
            try { sessionStorage.setItem('roamellow-'+key,String(event.target.checked)); } catch {}
          }
        }
      };
      this.addEventListener('change',this.changeHandler);
      this.sizeHandler=event=>{
        const dialog=this.querySelector('[data-size-dialog]');
        if(event.target.closest('[data-size-open]'))dialog.showModal();
        if(event.target.closest('[data-size-close]')||event.target===dialog||event.target.closest('[data-size-contact]'))dialog.close();
        const unit=event.target.closest('[data-size-unit]')?.dataset.sizeUnit;
        if(unit){dialog.querySelectorAll('[data-size-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.sizeUnit===unit)));dialog.querySelector('[data-size-label]').textContent=unit.toUpperCase();dialog.querySelectorAll('[data-cm]').forEach(cell=>{cell.textContent=unit==='cm'?cell.dataset.cm:(Number(cell.dataset.cm)/2.54).toFixed(1);});}
      };
      this.addEventListener('click',this.sizeHandler);
      this.paint(1);
    }
    syncPreferences() {
      for (const [selector,key] of [['[data-hh-protection]','protection'],['[data-hh-mystery-gift]','gift']]) {
        try { const saved=sessionStorage.getItem('roamellow-'+key); if(saved!==null)this.querySelectorAll(selector).forEach(input=>{input.checked=saved==='true';}); } catch {}
      }
    }
    syncSelections() {
      this.querySelectorAll('[data-pair]').forEach(row => {
        const value = this.selection[Number(row.dataset.pair)];
        row.querySelector('[data-roamellow-size]').value=value.size;
        const variant=this.variants.find(v=>v.option1===value.size);
        const image=row.querySelector('img');
        if(image&&variant?.featured_image?.src){image.src=variant.featured_image.src;image.removeAttribute('srcset');image.alt=value.style;}
      });
    }
    updateForm() {
      const value=this.selection[0];
      const offer=['Solo','Duo','Trio'][this.count-1];
      const variant=this.variants.find(v=>v.option1===value.size&&v.option2===offer);
      if(variant)this.root.querySelectorAll('product-form input[name="id"]').forEach(input=>{input.value=variant.id;});
    }
    paint(count) {
      this.count=Number(count);
      const selected=this.querySelector('.hh-offer-card[data-count="'+this.count+'"]');
      if(!selected)return;
      this.querySelectorAll('.hh-offer-card').forEach(card=>{card.dataset.active=String(card===selected);});
      this.querySelectorAll('input[type="radio"]').forEach(input=>{input.checked=Number(input.dataset.count)===this.count;});
      for(const [selector,value] of [['[data-hh-selected-price]',selected.dataset.offerPrice],['[data-hh-selected-compare]',selected.dataset.offerCompare],['[data-hh-selected-saving]','SAVE '+selected.dataset.offerSaving+'%']]){
        const element=this.querySelector(selector);if(element)element.textContent=value;
      }
      this.querySelector('[data-hh-selected-compare]').hidden=this.count===1;
      this.querySelector('[data-hh-selected-saving]').hidden=this.count===1;
      this.syncSelections();this.updateForm();
    }
    getSelections(){return Array.from(this.querySelectorAll('.hh-offer-card[data-active="true"] [data-pair]')).map(row=>({style:'Black',size:row.querySelector('[data-roamellow-size]').value}));}
    disconnectedCallback(){this.removeEventListener('click',this.sizeHandler);this.removeEventListener('change',this.changeHandler);this.ready=false;}
  }
  customElements.define('hh-offer-picker',HHOfferPicker);
}


